// Sibling apps a button/link can open via the mobile app's app-to-app jump,
// authored as { openApp: <id> }. IDs MUST match the APP_TARGETS keys in
// eca-mobile-expo/src/appTargets.js (and the web fallback map in eca-webapp).
export const APP_TARGET_OPTS = [
	{ id: 'acemeeting', name: 'ACE Meeting' },
	{ id: 'thalo', name: 'Thalo' },
];

export const appTargetName = id => {
	const found = APP_TARGET_OPTS.find(opt => opt.id === id);
	return found ? found.name : id;
};
